import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import service from '../../Service/Service';
import { getPackageDetailPath } from "../../utils/packagePaths";

const PageDealsSection = () => {
  const [umrahPackages, setUmrahPackages] = useState([]);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();

  useEffect(() => {
    const fetchPageData = async () => {
      setLoading(true);
      try {
        const packagesResponse = await service.getAllpackageUmrah().catch(err => {
          console.error('Failed to fetch packages for page display:', err);
          return { data: [] };
        });

        const allPackages = packagesResponse?.data || [];
        const pageUmrah = allPackages.filter((pkg) =>
          pkg.package_type === 'Umrah' &&
          (pkg.show_as_page === true || pkg.show_as_page === 1 || pkg.show_as_page === '1')
        );
        setUmrahPackages(pageUmrah);
      } catch (error) {
        console.error('Failed to fetch page data:', error);
        setUmrahPackages([]);
      } finally {
        setLoading(false);
      }
    };

    fetchPageData();
  }, []);

  if (!loading && umrahPackages.length === 0) {
    return null;
  }

  return (
    <div className="mt-6 mb-4 w-[90%] md:w-[80%] mx-auto space-y-6">
      {loading ? (
        <div className="flex justify-center items-center py-10">
          <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-secondary"></div>
        </div>
      ) : (
        <>
          {umrahPackages.length > 0 && (
            <section>
              <div className="mb-4">
                <h2 className="text-xl md:text-2xl font-bold text-gray-900 mb-2">
                  Popular Umrah Packages
                </h2>
              </div>
              <div className="flex flex-wrap gap-2">
                {umrahPackages.map((pkg) => (
                  <button
                    key={pkg.uid}
                    type="button"
                    onClick={() => navigate(getPackageDetailPath(pkg))}
                    className="px-4 py-3 rounded-md font-medium text-sm text-white bg-secondary hover:bg-navy-700 transition-colors"
                  >
                    {pkg.name || 'View Umrah package details'}
                  </button>
                ))}
              </div>
            </section>
          )}
        </>
      )}
    </div>
  );
};

export default PageDealsSection;
